import { SHORT_URL_EVENTS } from "@/modules/tracking/consts/Events";
import {
  ShortUrlFlowResult,
  ShortUrlTerminalState,
} from "@/modules/tracking/consts/ShortUrl";
import {
  endShortUrlFlowSession,
  getShortUrlFlowSession,
} from "@/modules/tracking/utils/shortUrlFlowSession";
import { trackShortUrlEvent } from "@/modules/tracking/utils/trackShortUrlEvent";

// No-op when no Short URL flow session is active.
export function completeShortUrlFlow(
  terminalState: ShortUrlTerminalState,
  options: {
    result?: ShortUrlFlowResult;
    extraProps?: Record<string, unknown>;
  } = {},
): void {
  const session = getShortUrlFlowSession();
  if (!session) return;

  const { result = "success", extraProps = {} } = options;

  trackShortUrlEvent(SHORT_URL_EVENTS.FLOW_COMPLETED, {
    flow: session.flow,
    session_id: session.sessionId,
    result,
    terminal_state: terminalState,
    ...extraProps,
  });

  endShortUrlFlowSession();
}
